export const WEB_CLIENT_ID =
  "622610144667-t4c1nu9hqt239gdina9otd2n8ajd41pl.apps.googleusercontent.com";
